import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '@mui/material';
import Comments from './components/Comments.js';
import DetailsForm from './components/DetailsForm.js';

const Details = (props) => {
	const { ticketId, comments, details } = props;
	return (
		<Grid container spacing={3}>
			<Grid item lg={7} xs={7}>
				<DetailsForm details={details} ticketId={ticketId} />
			</Grid>
			<Grid item lg={5} xs={5}>
				<Comments comments={comments} ticketId={ticketId} />
			</Grid>
		</Grid>
	);
};

Details.propTypes = {
	ticketId: PropTypes.number,
	details: PropTypes.object,
	comments: PropTypes.array,
};

export default Details;
